import React, { Component } from "react";
import _ from "lodash";
import AddressUpdateWindow from "../containers/AddressUpdateWindow.js";
import locales from "../../../_constants/locales";
import "../styles/GeneralInformationSection.css";
import StyledButton from "../../../components/StyledButton.jsx";

class GeneralInformationSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandedReturnItems: [],
            expandedReplacementItems: [],
            isUpdateAddressDialogOpen: false
        };
    }

    componentWillMount() {}

    componentDidMount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.ticketUpdating === false && prevProps.ticketUpdating === true && !this.props.ticketUpdatingError) {
            this.setState({
                isUpdateAddressDialogOpen: false
            });
        }
    }

    handleRequestAssistanceClick() {
        window.open("https://help.kobo.com/", "_blank", "noreferrer");
    }

    handleUpdateAddressClick() {
        this.setState({
            isUpdateAddressDialogOpen: true
        });
    }

    handleCancelAddressUpdateClick() {
        this.setState({
            isUpdateAddressDialogOpen: false
        });
        this.props.setTicketUpdate(this.props.ticketData);
    }

    isReturnAddressSameAsReplacementAddress() {
        return JSON.stringify(this.props.ticket.replacementAddress) === JSON.stringify(this.props.ticket.returnAddress);
    }

    handleSubmitAddressUpdateClick(replacementAddress, returnAddress) {
        let updatedTicket = { ...this.props.ticket, replacementAddress: replacementAddress, returnAddress: returnAddress };
        this.props.handleTicketUpdate(updatedTicket);
    }

    render() {
        return (
            <div className="flex layout vertical section general-information-section">
                <div className="flex layout horizontal center section-header">
                    <div className="flex layout horizontal center title-row">
                        <h2 className="title flex">{locales[this.props.language.code].TICKET.GENERAL_INFORMATION.TITLE}</h2>
                        <div className="actions layout horizontal end">
                            {this.props.ticket.addressUpdateAvailable && (
                                <StyledButton id="submit-button-id" onClick={this.handleUpdateAddressClick.bind(this)} variant="contained">
                                    {locales[this.props.language.code].TICKET.GENERAL_INFORMATION.UPDATE_ADDRESS}
                                </StyledButton>
                            )}
                        </div>
                        <AddressUpdateWindow
                            replacementAddress={this.props.ticketUpdate.replacementAddress}
                            returnAddress={this.props.ticketUpdate.returnAddress}
                            handleCancelClick={this.handleCancelAddressUpdateClick.bind(this)}
                            handleSubmit={this.handleSubmitAddressUpdateClick.bind(this)}
                            open={this.state.isUpdateAddressDialogOpen}
                        />
                    </div>
                </div>
                <div className="section-body">
                    <div className="flex layout general-information-boxes">
                        <div className="flex layout vertical general-information-box">
                            <h3 className="field-heading">{locales[this.props.language.code].TICKET.GENERAL_INFORMATION.PERSONAL_INFORMATION.TITLE}</h3>
                            <p className="field-data">
                                {`${this.props.ticket.personalInformation.firstName} ${this.props.ticket.personalInformation.lastName}`}
                            </p>
                            <p className="field-data">{this.props.ticket.personalInformation.emailAddress}</p>
                            <p className="field-data">{this.props.ticket.personalInformation.phoneNumber}</p>
                        </div>
                        {!this.isReturnAddressSameAsReplacementAddress() && (
                            <div className="flex layout vertical general-information-box">
                                <h3 className="field-heading">{locales[this.props.language.code].TICKET.GENERAL_INFORMATION.RETURN_ADDRESS.TITLE}</h3>
                                <div>
                                    <p className="field-data">{`${this.props.ticket.returnAddress.firstName} ${this.props.ticket.returnAddress.lastName}`}</p>
                                    <p className="field-data">{this.props.ticket.returnAddress.address1}</p>
                                    <p className="field-data">{this.props.ticket.returnAddress.address2}</p>
                                    <p className="field-data">{this.props.ticket.returnAddress.city}</p>
                                    <p className="field-data">{this.props.ticket.returnAddress.postalCode}</p>

                                    <p className="field-data">
                                        {this.props.ticket.returnAddress.province ? `${this.props.ticket.returnAddress.province.name}, ` : ""}
                                        {this.props.ticket.returnAddress.country.label}
                                    </p>
                                </div>
                            </div>
                        )}
                        <div className="flex layout vertical general-information-box">
                            <h3 className="field-heading">
                                {this.isReturnAddressSameAsReplacementAddress()
                                    ? locales[this.props.language.code].TICKET.GENERAL_INFORMATION.REPLACEMENT_ADDRESS.TITLE_SAME
                                    : locales[this.props.language.code].TICKET.GENERAL_INFORMATION.REPLACEMENT_ADDRESS.TITLE}
                            </h3>
                            <div>
                                <p className="field-data">
                                    {`${this.props.ticket.replacementAddress.firstName} ${this.props.ticket.replacementAddress.lastName}`}
                                </p>
                                <p className="field-data">{this.props.ticket.replacementAddress.address1}</p>
                                <p className="field-data">{this.props.ticket.replacementAddress.address2}</p>
                                <p className="field-data">{this.props.ticket.replacementAddress.city}</p>
                                <p className="field-data">{this.props.ticket.replacementAddress.postalCode}</p>
                                <p className="field-data">
                                    {this.props.ticket.replacementAddress.province ? `${this.props.ticket.replacementAddress.province.name}, ` : ""}
                                    {this.props.ticket.replacementAddress.country.label}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.ticket.addressUpdateAvailable && <div className="horizontal-separator-inner dynamic" />}
                {this.props.ticket.addressUpdateAvailable && (
                    <div className="section-footer">
                        <div className="mobile-actions">
                            <StyledButton id="submit-button-id" onClick={this.handleUpdateAddressClick.bind(this)} variant="contained">
                                {locales[this.props.language.code].TICKET.GENERAL_INFORMATION.UPDATE_ADDRESS}
                            </StyledButton>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default GeneralInformationSection;
